import { render, staticRenderFns } from "./BalancePanel.vue?vue&type=template&id=39870973&scoped=true"
import script from "./BalancePanel.vue?vue&type=script&lang=js"
export * from "./BalancePanel.vue?vue&type=script&lang=js"
import style0 from "./BalancePanel.vue?vue&type=style&index=0&id=39870973&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39870973",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39870973')) {
      api.createRecord('39870973', component.options)
    } else {
      api.reload('39870973', component.options)
    }
    module.hot.accept("./BalancePanel.vue?vue&type=template&id=39870973&scoped=true", function () {
      api.rerender('39870973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/dashboard/components/BalancePanel.vue"
export default component.exports